module.exports = "<select\r\n  #ddstatus\r\n  class=\"form-control ediReservationFontCls resetPadding\" name=\"status\" (ngModelChange)=\"onSelectStatus($event)\"\r\n  [(ngModel)]=\"tripstatusid\"\r\n  [ngClass]=\"{'notEditedBg': statusCls, 'hidedropDownArrowCls': hideDropDownArrow}\">\r\n  <option\r\n    *ngFor=\"let status of statusList; let i=index\"\r\n    [ngValue]=\"status.tripstatusid\"\r\n    [disabled]=\"_allowActive && status.disabled\">\r\n      {{status.description}}\r\n    </option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/drop-down-status/drop-down-status.component.html
// module id = 2323
// module chunks = 66